/*=========================================================================================
  File Name: module-usertax-getters.js
  Description: UserTax Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	getFilterTaxPaper(state) {
		return state.filterTaxPaper;
	},
	getFilterDisplayTaxPaper(state) {
		return state.filterDisplayTaxPaper;
	},
	getOptionsFilterTaxPaper(state) {
		return state.optionsFilterTaxPaper;
	}
};
